import { motion } from "framer-motion";
import PageTransition from "@/components/PageTransition";
import YearsSection from "@/components/YearsSection";
import Manifesto from "@/components/Manifesto";
import CTABlock from "@/components/CTABlock";
import { SITE } from "@/data/site";

export default function About() {
  return (
    <PageTransition>
      <section className="pt-40 md:pt-56 pb-24 md:pb-32 relative overflow-hidden" data-testid="about-page">
        <div className="absolute inset-0 halftone-bg opacity-30 halftone-fade pointer-events-none" aria-hidden />
        <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
          <div className="font-mono text-[11px] tracking-[0.32em] uppercase text-[color:var(--text-2)]">— About</div>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="font-display mt-6 text-[13vw] md:text-[112px] leading-[0.94] tracking-[-0.03em] max-w-[1200px]"
          >
            A printer's <em className="italic text-[color:var(--accent)]">printer.</em>
          </motion.h1>

          <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="md:col-span-6 md:col-start-1 text-[19px] md:text-[22px] leading-[1.55] text-[color:var(--text)]"
            >
              For more than three decades, {SITE.brand} has been trusted by businesses, publishers, professionals, and individuals for print work that arrives right — every time.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="md:col-span-5 md:col-start-8 text-[15.5px] text-[color:var(--text-2)] leading-[1.75] space-y-5"
            >
              <p>
                We work close to our clients. Every project passes through the same disciplined four-step process: Consult, Design &amp; Proof, Print, Deliver.
              </p>
              <p>
                We're small enough that the person answering your call is the person overseeing your job — and experienced enough that nothing about print surprises us anymore.
              </p>
              <p className="text-[color:var(--text)]">
                {SITE.legal}
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <Manifesto />
      <YearsSection />
      <CTABlock />
    </PageTransition>
  );
}
